export default "__VITE_ASSET__f59ec35e__"